<template lang="html">
    <v-form ref="form" v-model="isValid" @submit.prevent="">
        <v-container grid-list-xs>
            <v-layout wrap>
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs12>
                            <v-select
                              :items="suppliers"
                              v-model="supplier_id"
                              label="Fournisseur"
                              item-text="name"
                              item-value="id"
                              autocomplete
                              autofocus
                              ref="select"
                              clearable
                              @keyup.enter.native="addTag($event)"
                              :loading="loading"
                            >
                            <template slot="selection" slot-scope="data">
                                <v-chip>
                                    {{ data.item.name }}
                                </v-chip>
                            </template>
                            <template slot="item" slot-scope="data">
                                <template v-if="typeof data.item === 'object'">
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{ data.item.name }}</v-list-tile-title>
                                    </v-list-tile-content>
                                </template>
                            </template>
                            <template slot="no-data">
                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-title>Appuyer sur Entrer pour ajouter</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </template>
                            </v-select>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-container>
    </v-form>
</template>

<script>
    export default {
        data(){
            return {
                title: 'Modifier le fournisseur',
                icon:     'find_replace',
                isValid:  false,
                suppliers: [],
                supplier_id: null,
                loading: false,
                disableEnter: true
            }
        },
        methods: {
            onClose() {
                this.$eventHub.$emit('close-modal')
            },
            onValidate(){
                if(this.$refs.form.validate()){
                    this.axios.put(`/api/products/${this.$store.state.single.data.id}`, {supplier_id: this.supplier_id})
                    .then(response => {
                        this.$store.dispatch('updateSingleData', { key:'supplier_id', value:this.supplier_id })
                        this.$store.dispatch('updateSingleData', { key:'supplier', value: this.$_.find(this.suppliers,p => p.id == this.supplier_id)})
                        this.onClose()
                    })
                } else {
                    this.onClose()
                }
            },
            addTag(val){
                if(val.target.value != "" && this.suppliers.filter(s => s.name == val.target.value).length == 0){
                    this.axios.post(`/api/suppliers`, {name:val.target.value})
                    .then(response => {
                        this.suppliers.push(response.data)
                        this.supplier_id = response.data.id
                        if(this.$refs.select) {
                            this.$refs.select.searchValue = null
                        }
                    })
                }
            },
            getSuppliers() {
                this.axios.get(`/api/suppliers`)
                .then(response => {
                    this.suppliers = response.data
                    if(this.$store.state.single.data.supplier_id != null) {
                        this.project_id = this.$store.state.single.data.supplier_id
                    }
                    this.loading = false
                })
            }
        },
        mounted() {
            this.loading=true
            this.getSuppliers()
        },
    }
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/views/products/single/UpdateSupplier.vue